import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Store } from "Reducers/interface";
import validatePermissions from "Utils/validatePermissions";
import { MaskCPF } from "Utils/Masks";
import { TableItemStyle } from "../styles";

export type Order = {
  order_id: number;
  client_id: number;
  client_name: string;
  id_source: number;
  date: string;
  pacient_id: number;
  pacient_name: string;
  pacient_cpf: string;
  pacient_email: string;
  subtotal: string;
  discounts: string;
  total: string;
  paid_value: string;
  coupon_code: boolean;
  home_collected: boolean;
  home_collect_date: string;
  status: string;
  order_source: string;
  origin_order_id: number;
  order_type: number;
  motion_integration_status: string;
  unit_id: number;
  unit_name: string;
  compound_order: boolean;
};

export interface TableItemProps {
  order: Order;
}

export const TableItem = ({ order }: TableItemProps) => {
  const user_permissions = useSelector(
    (state: Store) => state.User.permissions
  );

  const {
    date,
    origin_order_id,
    pacient_name,
    pacient_cpf,
    pacient_email,
    home_collected,
    home_collect_date,
    status,
    paid_value,
    order_id,
    order_type,
    client_name,
    motion_integration_status,
  } = order;

  const hasPermission = validatePermissions(
    "Send Orders to Motion",
    user_permissions
  );

  const waitingSendMotion = motion_integration_status === "Aguardando Envio";

  const isHomeCollect = home_collected || home_collect_date;

  return (
    <TableItemStyle>
      <td>{date} </td>
      <td>{origin_order_id} </td>
      <td>{pacient_name} </td>
      <td>{MaskCPF(pacient_cpf)} </td>
      <td>{pacient_email} </td>
      <td>{isHomeCollect ? "Coleta Domiciliar" : "Unidade"} </td>
      <td>{client_name}</td>

      <td className="table-action-order">

        {
          waitingSendMotion ?
          <Link
            type="button"
            className={`button _blue _action 
              ${hasPermission ? "" : "disabled"}
              ${waitingSendMotion ? "" : "disabled"}`}
            to={
              order_type === 5
                ? `/pedido/revisar/${order_id}`
                : `/pedidos-envio/${order_id}`
            }
          >
          Enviar
          </Link> : motion_integration_status
        }
      
      </td>
      <td>R$ {paid_value} </td>
      <td className="table-action-order">
        <Link
          to={`/ficha-de-pedido/${order_id}`}
          className="button _white _action"
          type="button"
        >
          <span className="details-text">Visualizar</span>
        </Link>
      </td>
    </TableItemStyle>
  );
};
